import styled from 'styled-components';

export const Container = styled.div.attrs({
  className:
    'fixed bottom-0 left-0 right-0 bg-white border-t border-border shadow-lg z-50 mx-auto px-4 py-3',
})``;

export const Content = styled.div.attrs({
  className: 'flex justify-between items-center w-full max-w-6xl mx-auto',
})``;
